<template>
  <div v-if="order" class="milestones">
    <ul class="milestones__list">
      <li v-for="event in processedEvents" :key="event.id">
        <button
          class="milestone-item"
          :class="{ 'milestone-item--active': event.actual }"
          :style="
            event.actual
              ? { borderColor: event.color, background: event.color }
              : {}
          "
          @click="goToVideoMoment(event.start)"
        >
          <span class="milestone-item__label">{{ event.label }}</span>
          <span v-if="event.actual" class="milestone-item__dot" />
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import moment from "moment";
moment.locale("es");

export default {
  name: "MilestonesView",
  props: ["order", "currentTime", "events"],
  computed: {
    realTime() {
      return moment(this.order.start_date)
        .add(this.currentTime, "seconds")
        .format("HH:mm:ss - DD/MM/YYYY");
    },
    processedEvents() {
      if (!this.events || !this.order) {
        return [];
      }
      const transformedEvents = this.events.map((event) => {
        let startInSeconds;
        if (event.videoStartOffset !== undefined) {
          startInSeconds = event.videoStartOffset;
        } else {
          const videoStartTime = new Date(this.order.videoStart).getTime();
          startInSeconds =
            (new Date(event.startedAt).getTime() - videoStartTime) / 1000;
        }
        const endInSeconds =
          event.videoEndOffset !== undefined
            ? event.videoEndOffset
            : (new Date(event.endedAt).getTime() -
                new Date(this.order.videoStart).getTime()) /
              1000;
        let label = event.eventId;
        if (event.childOrderIndex) {
          label = `${event.eventId} (${event.childOrderIndex})`;
        }
        return {
          id: event.id,
          label: label,
          start: startInSeconds,
          end: endInSeconds,
          actual: false,
          color: event.eventColor || "#86da00",
        };
      });
      for (let event of transformedEvents) {
        if (event.start <= this.currentTime && event.end >= this.currentTime) {
          event.actual = true;
        } else {
          event.actual = false;
        }
      }
      return transformedEvents;
    },
  },
  methods: {
    goToVideoMoment(time) {
      this.$emit("goto", time + 0.1);
    },
  },
};
</script>

<style scoped>
.milestones {
  padding: 0;
}

.milestones__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.milestone-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 8px 12px;
  border-radius: 7px;
  border: 1.5px solid #e2e8f0;
  background: #fff;
  color: #0f172a;
  font-size: 13px;
  font-weight: 400;
  font-family: inherit;
  text-align: left;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.milestone-item:hover {
  border-color: #0284c7;
  color: #0284c7;
}

.milestone-item--active {
  color: #fff;
  font-weight: 700;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.milestone-item--active:hover {
  filter: brightness(0.92);
  color: #fff;
}

.milestone-item__label {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.milestone-item__dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #fff;
  flex-shrink: 0;
  margin-left: 8px;
  animation: pulseDot 1.5s ease infinite;
}

@keyframes pulseDot {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
}
</style>
